function moveAuthorContactToAvatar() {
  document.querySelectorAll( '.pp-author-boxes-avatar-details' ).forEach( details => {
    const paragraphs = details.querySelectorAll( 'p' );
    paragraphs.forEach( p => {
      if (
        p.querySelector( '.ppma-author-user_email-profile-data' ) ||
        p.querySelector( '.ppma-author-field-type-url' )
      ) {
        const avatarBox = details
          .closest( '.pp-multiple-authors-boxes-li' )
          ?.querySelector( '.pp-author-boxes-avatar' );
        if ( avatarBox ) {
          avatarBox.appendChild( p );
        }
      }
    } );
  } );
}

moveAuthorContactToAvatar();
